import { render } from "./AddModalTypeContainer.vue?vue&type=template&id=228de5da&ts=true"
import script from "./AddModalTypeContainer.vue?vue&type=script&lang=ts"
export * from "./AddModalTypeContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__